/**
 * Handles mobile navigation menu behavior for category dropdowns.
 * @returns {void}
 */
function mobileNavMenu() {
    // Unsure if this is needed
    $(".category-navigation .dropdown-toggle").click(function () {
        1040 <= $(document).width() && (document.location = $(this).attr("href"));
    });
}

export {mobileNavMenu};
